/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function DefaultReservationCards({
  title,
  userName,
  userEmail,
  selectedTime,
  buyAt,
  isValid,
  index
}) {
  return (
    <Card>
      <MDBox pb={2} px={2} textAlign="center" lineHeight={1.25}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          {index + 1} - {title}
        </MDTypography>
        {userName && (
          <>
            <Divider />
            <MDTypography variant="caption" color="text" fontWeight="regular">
              {userName}
            </MDTypography>
          </>
        )}
        {userEmail && (
          <>
            <Divider />
            <MDTypography variant="caption" color="text" fontWeight="regular">
              {userEmail}
            </MDTypography>
          </>
        )}
        {selectedTime && (
          <>
            <Divider />
            <MDTypography variant="caption" color="text" fontWeight="regular">
              {selectedTime}
            </MDTypography>
          </>
        )}
        {buyAt && (
          <>
            <Divider />
            <MDTypography variant="caption" color="text" fontWeight="regular">
              {buyAt}
            </MDTypography>
          </>
        )}
        {/* {description && !value ? null : <Divider />} */}
        {/* {value && (
          <MDTypography variant="h5" fontWeight="medium">
            {value}
          </MDTypography>
        )} */}
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of DefaultReservationCards
DefaultReservationCards.defaultProps = {
  color: "info",
  value: "",
  description: "",
};

// Typechecking props for the DefaultReservationCards
DefaultReservationCards.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DefaultReservationCards;
